import { axiosAPI as axios } from 'utils';

export const registerMobilePushDevice = (data) => (
  axios.post('/api/mobile-v2/push/devices/register', data).then((response) => response?.data || response)
);

export const registerMobileFamilyPushDevice = (data) => (
  axios.post('/api/mobile-wrapper/push/devices/register', data).then((response) => response?.data || response)
);

export const unregisterMobilePushDevice = (data) => (
  axios.delete('/api/mobile-v2/push/devices/current', { data }).then((response) => response?.data || response)
);
